import { render } from "./Attendees.vue?vue&type=template&id=d585cdcc&scoped=true"
import script from "./Attendees.vue?vue&type=script&lang=js"
export * from "./Attendees.vue?vue&type=script&lang=js"

import "./Attendees.vue?vue&type=style&index=0&id=d585cdcc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d585cdcc"]])

export default __exports__